
export default function EventsSection() {
  const upcomingEvents = [
    {
      title: 'Annual Student Conference',
      date: 'March 15-17, 2024',
      location: 'Toronto, ON',
      type: 'Conference',
      description: 'Three days of workshops, networking, and keynote presentations from industry leaders',
      color: 'blue'
    },
    {
      title: 'One Health Symposium',
      date: 'April 8, 2024',
      location: 'Virtual Event',
      type: 'Symposium',
      description: 'Exploring the interconnections between human, animal, and environmental health',
      color: 'green'
    },
    {
      title: 'Career Fair & Job Expo',
      date: 'April 22, 2024',
      location: 'Calgary, AB',
      type: 'Career Event',
      description: 'Meet with top employers in pharmacy and veterinary fields',
      color: 'purple'
    },
    {
      title: 'Research Poster Session',
      date: 'May 10, 2024',
      location: 'Vancouver, BC',
      type: 'Academic',
      description: 'Present your research and learn from peer presentations',
      color: 'orange'
    },
    {
      title: 'Leadership Workshop Series',
      date: 'Monthly',
      location: 'Various Cities',
      type: 'Workshop',
      description: 'Develop leadership skills through interactive workshops and mentoring',
      color: 'indigo'
    },
    {
      title: 'Mental Health & Wellness Retreat',
      date: 'June 5-7, 2024',
      location: 'Banff, AB',
      type: 'Wellness',
      description: 'Focus on self-care, stress management, and work-life balance',
      color: 'pink'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    purple: 'bg-purple-100 text-purple-600',
    orange: 'bg-orange-100 text-orange-600',
    indigo: 'bg-indigo-100 text-indigo-600',
    pink: 'bg-pink-100 text-pink-600'
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Upcoming Events
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join us for exciting events designed to enhance your education, build connections, and support your professional development
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {upcomingEvents.map((event, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${colorClasses[event.color]}`}>
                  {event.type}
                </span>
                <i className="ri-calendar-event-line text-2xl text-gray-400"></i>
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {event.title}
              </h3>
              
              <p className="text-gray-600 mb-4">
                {event.description}
              </p>
              
              <div className="space-y-2 text-sm text-gray-700">
                <div className="flex items-center">
                  <i className="ri-calendar-line text-blue-500 mr-2"></i>
                  <span>{event.date}</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-green-500 mr-2"></i>
                  <span>{event.location}</span>
                </div>
              </div>
              
              <button className="w-full mt-4 bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                Register Now
              </button>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">
            Stay Updated on Events
          </h3>
          <p className="text-blue-100 mb-6">
            Subscribe to our student newsletter for event notifications and exclusive opportunities
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-4 py-2 rounded-lg border-0 focus:ring-2 focus:ring-blue-300 text-gray-900"
            />
            <button className="bg-white text-blue-600 px-6 py-2 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
